import { KeyboardScanner } from '@/kiosk-core/scanner/keyboardScanner';

export type {
  KeyboardScannerOptions,
  ScanCallback,
  ScannerLease,
} from '@/kiosk-core/scanner/keyboardScanner';
export { KeyboardScanner as EntrScanner };

export const entrScanner = new KeyboardScanner();
